import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { User } from "@nousmedis/guard-types/dist/frontend";
import { AuthModel } from "@nousmedis/nm-guard-auth";

@Injectable({
    providedIn: "root",
})
export class LoginActivate implements CanActivate {
    user: User | undefined;

    constructor (
        private router: Router,
        private auth: AuthModel
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        this.user = this.auth.getCurrentUser();
        if (!this.user) {
            this.router.navigate(["/login"]);
            return false;
        }
        return true;
    }
}
